import { DateInput as MantineDateInput, DateInputProps as MantineDateInputProps } from '@mantine/dates';
import { FC } from 'react';

import inputStyles from '../../styles/Input.module.css';
import datePickerStyles from '../styles/DatePicker.module.css';

import { CalendarIcon } from '../../../icons/CalendarIcon';
import { handleGetDayProps, handleGetMonthControlProps, handleGetYearControlProps } from '../utils';
import { WithRequired } from '../../../types/withRequired';

export type DateInputProps = WithRequired<MantineDateInputProps, 'aria-label'>;

export const DateInput: FC<DateInputProps> = props => {
    return (
        <MantineDateInput
            classNames={{
                input: inputStyles.input,
                label: inputStyles.label,
                description: inputStyles.description,
                required: inputStyles.required,
                day: datePickerStyles.day,
                monthCell: datePickerStyles.monthCell,
                calendarHeaderLevel: datePickerStyles.calendarHeaderLevel,
                monthsListControl: datePickerStyles.monthsListControl,
                yearsListControl: datePickerStyles.yearsListControl,
            }}
            rightSection={<CalendarIcon />}
            getDayProps={handleGetDayProps}
            getYearControlProps={handleGetYearControlProps}
            getMonthControlProps={handleGetMonthControlProps}
            rightSectionPointerEvents="none"
            {...props}
        />
    );
};
